module.exports = __webpack_public_path__ + "media/images/teams/PARMA-5546e1779ae40ae0390de7cac9c36cf9.png";